// BF Early Access ($1 VIP Pass) landing — page.bf-early-access
// Header (announcement, explore dropdown, side menu), anchor scroll. Sections add their parts below.

var BFEA_ANN_KEY = "bfeaAnnClosed";

function bfeaLock(on) {
  $("html").toggleClass("bfea-locked", on);
}

function bfeaOpenMenu() {
  $("[data-bfea-menu]").addClass("is-open").attr("aria-hidden", "false");
  bfeaLock(true);
}

function bfeaCloseMenu() {
  $("[data-bfea-menu]").removeClass("is-open").attr("aria-hidden", "true");
  bfeaLock(false);
}

function bfeaScrollTo(hash) {
  var $target = $(hash);
  if (!$target.length) return;
  // native smooth scroll: the theme sets scroll-behavior: smooth on html, which makes jQuery animate lag
  window.scrollTo({ top: $target.offset().top, behavior: "smooth" });
}

function bfeaInitAnnouncement() {
  try {
    if (sessionStorage.getItem(BFEA_ANN_KEY)) $("[data-bfea-ann]").addClass("is-hidden");
  } catch (e) {}
}

$(document).ready(function () {
  bfeaInitAnnouncement();

  $(document).on("click", "[data-bfea-ann-close]", function () {
    $("[data-bfea-ann]").addClass("is-hidden");
    try { sessionStorage.setItem(BFEA_ANN_KEY, "1"); } catch (e) {}
  });

  $(document).on("click", "[data-bfea-menu-open]", bfeaOpenMenu);
  $(document).on("click", "[data-bfea-menu-close]", bfeaCloseMenu);

  $(document).on("click", "[data-bfea-anchor-link]", function (e) {
    var hash = $(this).attr("href");
    if (!hash || hash.charAt(0) !== "#") return;
    e.preventDefault();
    bfeaCloseMenu();
    bfeaScrollTo(hash);
  });

  $(document).on("click", "[data-bfea-top]", function (e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  $(document).on("keydown", function (e) {
    if (e.key === "Escape") bfeaCloseMenu();
  });
});

// Sticky CTA bar (mobile): visible once the hero CTA has scrolled above the viewport,
// hidden while the final CTA section or the footer is in view.

var bfeaStickyState = { passed: false, final: false, foot: false };

function bfeaStickyRender() {
  var on = bfeaStickyState.passed && !bfeaStickyState.final && !bfeaStickyState.foot;
  $("[data-bfea-sticky]").toggleClass("is-visible", on).attr("aria-hidden", on ? "false" : "true");
}

function bfeaStickyWatch(selector, onChange) {
  var el = document.querySelector(selector);
  if (!el) return false;
  new IntersectionObserver(function (entries) {
    onChange(entries[entries.length - 1]);
    bfeaStickyRender();
  }).observe(el);
  return true;
}

function bfeaInitSticky() {
  if (!$("[data-bfea-sticky]").length || !("IntersectionObserver" in window)) return;
  var hasHero = bfeaStickyWatch(".bfea-hero__cta", function (e) {
    bfeaStickyState.passed = !e.isIntersecting && e.boundingClientRect.top < 0;
  });
  if (!hasHero) bfeaStickyState.passed = true;
  bfeaStickyWatch(".bfea-final", function (e) { bfeaStickyState.final = e.isIntersecting; });
  bfeaStickyWatch(".bfea-foot", function (e) { bfeaStickyState.foot = e.isIntersecting; });
  bfeaStickyRender();
}

$(document).ready(function () {
  bfeaInitSticky();
});

// Builder (sections/bfea-builder.liquid): toggle product cards, recompute the VIP savings estimate (cents).

function bfeaBuilderMoney(cents) {
  return "$" + (cents / 100).toFixed(2);
}

function bfeaBuilderUpdate($b) {
  var pct = +$b.data("pct"), credit = +$b.data("credit"), threshold = +$b.data("threshold"), sub = 0;
  $b.find('[data-bfea-card][aria-pressed="true"]').each(function () {
    sub += +$(this).data("price");
  });
  var discount = Math.round(sub * pct / 100);
  var on = sub > 0 && sub >= threshold;
  var cr = on ? credit : 0;
  var need = Math.max(threshold - sub, 0) / 100;
  $b.find("[data-bfea-subtotal]").text(bfeaBuilderMoney(sub));
  $b.find("[data-bfea-discount]").text("-" + bfeaBuilderMoney(discount));
  $b.find("[data-bfea-final]").text(bfeaBuilderMoney(Math.max(sub - discount - cr, 0)));
  $b.find("[data-bfea-saved]").text(bfeaBuilderMoney(discount + cr));
  $b.find("[data-bfea-need]").text(need % 1 ? need.toFixed(2) : need);
  $b.find("[data-bfea-credit-on]").prop("hidden", !on);
  $b.find("[data-bfea-credit-off]").prop("hidden", on);
}

$(document).ready(function () {
  $(document).on("click", "[data-bfea-card]", function () {
    var $card = $(this);
    $card.attr("aria-pressed", $card.attr("aria-pressed") !== "true");
    bfeaBuilderUpdate($card.closest("[data-bfea-builder]"));
  });
});

// Reviews slider (bfea-reviews): arrows, dots, swipe, loop. Slides crossfade via [aria-hidden] in CSS.

var bfeaRsTouchX = null;
var bfeaRsTouchY = null;

function bfeaRsGo($rs, i) {
  var $slides = $rs.find("[data-bfea-rs-slide]");
  var n = $slides.length;
  if (!n) return;
  i = (i + n) % n;
  $rs.data("index", i);
  $slides.attr({ "aria-hidden": "true", inert: "" }).eq(i).removeAttr("aria-hidden inert");
  $rs.find("[data-bfea-rs-dots]").each(function () {
    $(this).find("[data-bfea-rs-dot]").removeClass("is-active").eq(i).addClass("is-active");
  });
}

function bfeaRsStep(el, step) {
  var $rs = $(el).closest("[data-bfea-rs]");
  bfeaRsGo($rs, ($rs.data("index") || 0) + step);
}

$(document).ready(function () {
  $(document).on("click", "[data-bfea-rs-prev]", function () { bfeaRsStep(this, -1); });
  $(document).on("click", "[data-bfea-rs-next]", function () { bfeaRsStep(this, 1); });

  $(document).on("click", "[data-bfea-rs-dot]", function () {
    bfeaRsGo($(this).closest("[data-bfea-rs]"), +$(this).attr("data-bfea-rs-dot"));
  });

  $(document).on("touchstart", "[data-bfea-rs-track]", function (e) {
    var t = e.originalEvent.touches[0];
    bfeaRsTouchX = t.clientX;
    bfeaRsTouchY = t.clientY;
  });

  $(document).on("touchend", "[data-bfea-rs-track]", function (e) {
    if (bfeaRsTouchX === null) return;
    var t = e.originalEvent.changedTouches[0];
    var dx = t.clientX - bfeaRsTouchX;
    var dy = t.clientY - bfeaRsTouchY;
    bfeaRsTouchX = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) bfeaRsStep(this, dx < 0 ? 1 : -1);
  });
});

// FAQ accordion (bfea-faq): one open at a time, smooth height, first item open on mobile (is-open-m)

function bfeaFaqSet($item, open) {
  var $a = $item.find("[data-bfea-faq-a]");
  var el = $a[0];
  $a.css("height", el.offsetHeight + "px");
  $item.toggleClass("is-open", open).removeClass("is-open-m");
  $item.find("[data-bfea-faq-q]").attr("aria-expanded", open ? "true" : "false");
  el.offsetHeight;
  $a.css("height", open ? el.scrollHeight + "px" : "0px");
}

function bfeaFaqInit() {
  var mob = window.matchMedia("(max-width: 989px)").matches;
  $("[data-bfea-faq-item].is-open-m").each(function () {
    if (mob) $(this).addClass("is-open").find("[data-bfea-faq-q]").attr("aria-expanded", "true");
    $(this).removeClass("is-open-m");
  });
}

$(document).ready(function () {
  bfeaFaqInit();

  $(document).on("click", "[data-bfea-faq-q]", function () {
    var $item = $(this).closest("[data-bfea-faq-item]");
    var open = !$item.hasClass("is-open");
    $item.siblings(".is-open").each(function () { bfeaFaqSet($(this), false); });
    bfeaFaqSet($item, open);
  });

  $(document).on("transitionend", "[data-bfea-faq-a]", function (e) {
    if (e.target === this && e.originalEvent.propertyName === "height") $(this).css("height", "");
  });
});

// ---------- $1 VIP pass popup: open/close, validation, Klaviyo, checkout ----------
// Same Klaviyo client API call as cs_quiz.js (email subscription to the list).

var BFEA_KLAVIYO_API = "https://a.klaviyo.com/client";
var BFEA_KLAVIYO_REVISION = "2025-07-15";
var bfeaLastFocus = null;

function bfeaOpenModal(success) {
  var $modal = $("[data-bfea-modal]");
  if (!$modal.length) return;
  bfeaLastFocus = document.activeElement;
  bfeaCloseMenu();
  $modal.toggleClass("is-success", !!success).addClass("is-open").attr("aria-hidden", "false");
  bfeaLock(true);
  setTimeout(function () {
    var $box = $modal.find(success ? "[data-bfea-modal-success]" : "[data-bfea-modal-form]");
    $box.find(success ? ".bfea-modal__back" : "input").first().trigger("focus");
  }, 50);
}

function bfeaCloseModal() {
  var $modal = $("[data-bfea-modal]");
  if (!$modal.hasClass("is-open")) return;
  $modal.removeClass("is-open").attr("aria-hidden", "true");
  bfeaLock(false);
  if (bfeaLastFocus) $(bfeaLastFocus).trigger("focus");
}

function bfeaPhoneE164(value) {
  var raw = $.trim(value);
  var digits = raw.replace(/\D/g, "");
  if (raw.charAt(0) === "+") return digits.length >= 8 && digits.length <= 15 ? "+" + digits : "";
  if (digits.length === 10) return "+1" + digits;
  if (digits.length === 11 && digits.charAt(0) === "1") return "+" + digits;
  return "";
}

function bfeaValidate($form) {
  var name = $.trim($form.find("[name=name]").val());
  var email = $.trim($form.find("[name=email]").val()).toLowerCase();
  var phone = bfeaPhoneE164($form.find("[name=phone]").val());
  $form.find("[name=name]").closest(".bfea-field").toggleClass("is-invalid", name.length < 2);
  $form.find("[name=email]").closest(".bfea-field").toggleClass("is-invalid", !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email));
  $form.find("[name=phone]").closest(".bfea-field").toggleClass("is-invalid", !phone);
  if ($form.find(".is-invalid").length) {
    $form.find(".is-invalid input").first().trigger("focus");
    return null;
  }
  var parts = name.split(/\s+/);
  return { name: name, first: parts.shift(), last: parts.join(" "), email: email, phone: phone };
}

function bfeaKlaviyoBody(data, listId, source) {
  return {
    data: {
      type: "subscription",
      attributes: {
        custom_source: source,
        profile: {
          data: {
            type: "profile",
            attributes: {
              email: data.email,
              phone_number: data.phone,
              properties: { bf_vip_pass_lead: true, bf_vip_pass_page: location.pathname, bf_vip_pass_name: data.name },
              subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } }
            }
          }
        }
      },
      relationships: { list: { data: { type: "list", id: String(listId) } } }
    }
  };
}

function bfeaKlaviyoPost(companyId, body) {
  return fetch(BFEA_KLAVIYO_API + "/subscriptions/?company_id=" + companyId, {
    method: "POST",
    headers: { "Content-Type": "application/vnd.api+json", revision: BFEA_KLAVIYO_REVISION },
    body: JSON.stringify(body),
    keepalive: true
  }).catch(function () {});
}

function bfeaKlaviyoSubscribe($modal, data) {
  var listId = $modal.attr("data-list-id");
  var companyId = $modal.attr("data-klaviyo-company");
  var source = $modal.attr("data-source") || "BF VIP Pass";
  if (!listId || !companyId) return Promise.resolve();
  return bfeaKlaviyoPost(companyId, bfeaKlaviyoBody(data, listId, source));
}

function bfeaCheckoutUrl(variantId, data) {
  var q = [
    "checkout[email]=" + encodeURIComponent(data.email),
    "checkout[shipping_address][first_name]=" + encodeURIComponent(data.first),
    "checkout[shipping_address][last_name]=" + encodeURIComponent(data.last),
    "checkout[shipping_address][phone]=" + encodeURIComponent(data.phone),
    "attributes[bf_vip_pass]=1"
  ];
  return "/cart/" + variantId + ":1?" + q.join("&");
}

function bfeaSubmitPass(e) {
  e.preventDefault();
  var $form = $(this);
  var $modal = $form.closest("[data-bfea-modal]");
  var variantId = $modal.attr("data-variant-id");
  var $pay = $form.find("[data-bfea-pay]");
  if ($pay.hasClass("is-loading")) return;
  var data = bfeaValidate($form);
  if (!data) return;
  // Subscribe to Klaviyo on every valid submit, even before the pass product exists.
  var subscribed = bfeaKlaviyoSubscribe($modal, data);
  if (typeof fireLead === "function") fireLead("bf_vip_pass", "bfea-pass-modal", data.email);
  if (!variantId) {
    $form.find("[data-bfea-form-error]").addClass("is-visible");
    return;
  }
  $pay.addClass("is-loading");
  // Go to checkout once Klaviyo answered, at most 2.5s later (keepalive lets the request finish anyway).
  var done = false;
  function go() {
    if (done) return;
    done = true;
    window.location.href = bfeaCheckoutUrl(variantId, data);
  }
  subscribed.then(go);
  setTimeout(go, 2500);
}

// CTA click: add the $1 VIP pass to the cart, or only open the drawer when the cart already has it.
var bfeaAdding = false;

function bfeaAddPass() {
  var id = Number($("[data-bfea-modal]").attr("data-variant-id"));
  if (!id || bfeaAdding) return;
  bfeaAdding = true;
  fetch("/cart.js", { cache: "no-store" })
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      var inCart = cart.items.some(function (item) {
        return item.variant_id === id;
      });
      if (inCart) {
        window.openCartDrawer();
        return;
      }
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: id, quantity: 1, sections: "cell_cart_drawer" })
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          window.refreshCartDrawer(false, data.sections);
          window.openCartDrawer(true);
        });
    })
    .catch(function () {})
    .then(function () {
      bfeaAdding = false;
    });
}

$(document).ready(function () {
  $(document).on("click", "[data-bfea-open]", function (e) {
    e.preventDefault();
    bfeaAddPass();
  });

  $(document).on("click", "[data-bfea-modal-close]", function (e) {
    e.preventDefault();
    bfeaCloseModal();
  });

  $(document).on("keydown", function (e) {
    if (e.key === "Escape") bfeaCloseModal();
    if (e.key !== "Tab") return;
    var $box = $("[data-bfea-modal].is-open .bfea-modal__box:visible");
    if (!$box.length) return;
    var $f = $box.find("a[href], button, input").filter(":visible");
    if (e.shiftKey && document.activeElement === $f[0]) {
      e.preventDefault();
      $f.last().trigger("focus");
    } else if (!e.shiftKey && document.activeElement === $f[$f.length - 1]) {
      e.preventDefault();
      $f.first().trigger("focus");
    }
  });

  $(document).on("input", ".bfea-field.is-invalid input", function () {
    $(this).closest(".bfea-field").removeClass("is-invalid");
  });

  $(document).on("submit", "[data-bfea-pass-form]", bfeaSubmitPass);

  if (/[?&]vip=confirmed(&|$)/.test(location.search)) bfeaOpenModal(true);
});
